import { createSlice } from '@reduxjs/toolkit';
import { getBatchDefinitionParameters } from 'ducks/bacth-definition-parameters/operators';
import { Slices } from 'ducks/slices';
import { ProjectParameters } from 'ducks/types/store-types';
import { normalizeParameters } from 'ducks/utils';

const initialState: ProjectParameters = [];

const batchDefinitionParametersSlice = createSlice({
  name: Slices.BATCH_DEFINITION_PARAMETERS,
  initialState,
  reducers: {
    clearParameters: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBatchDefinitionParameters.pending, () => {
        return initialState;
      })
      .addCase(getBatchDefinitionParameters.fulfilled, (_, { payload }) => {
        return normalizeParameters(payload);
      })
      .addCase(getBatchDefinitionParameters.rejected, () => {
        return initialState;
      });
  },
});

export const { clearParameters } = batchDefinitionParametersSlice.actions;

export default batchDefinitionParametersSlice.reducer;
